import './index.css';



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/wea-portal-share/style/index.js